(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqblock"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Get all the accordion buttons
  var accordionButtons = document.querySelectorAll('.faq-question');

  // Add a click event listener to each button
  accordionButtons.forEach(function(button) {
    button.addEventListener('click', function() {

      const content = this.nextElementSibling;

      // Toggle the 'active' class on the button
      this.classList.toggle('active');

      // Toggle the content's max-height to expand/collapse
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
      }      
      
    });
  });
});  

  } catch(e) { console.error(e); }
})();
})();
